export default "__VITE_ASSET__DnxFneGZ__"